<template>
  <div>
    <vx-card title="BULK DATA UPLOAD TEMPLATES">
      <div class="divide-y">
        <div v-for="(template, index) in template_list" :key="index"
          class="flex items-center px-6 py-4 border border-1 rounded mb-3">
          <!-- Template Info -->
          <div>
            <p class="text-sm font-medium text-gray-800">
              {{ formatName(template.name) }}
            </p>
            <p class="text-xs text-gray-500">
              Excel Template (.xlsx)
            </p>
          </div>

          <!-- Download Button -->
          <vs-button @click="downloadFile(template)" class="ml-16" size="small" type="border" icon-pack="feather" icon="icon-download">
            Download
          </vs-button>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
import SequenceUpdatePopUp from "@/components/popups/tenants/SequenceUpdatePopUp";

const TenantRepository = RepositoryFactory.get('tenant');

export default {
  name: "BulkUploadTemplates",
  components: {
    SequenceUpdatePopUp
  },
  data() {
    return {
      tenantId: '',
      template_list: [
        {
          name: 'Customers Template',
          url: 'customers'
        },
        {
          name: 'Customer Sites Template',
          url: 'customer/sites'
        },
        {
          name: 'Suppliers Template',
          url: 'suppliers'
        },
        {
          name: 'Raw Materials Template',
          url: 'raw-materials'
        },
        {
          name: 'Sundry Items Template',
          url: 'sundry-items'
        },
        {
          name: 'Other services Template',
          url: 'other-services'
        },
        {
          name: 'Formulations Template',
          url: 'formulations'
        },
        {
          name: 'Raw Material Stock Template',
          url: 'raw-material-stock'
        },
        {
          name: 'Sundry Item Stock Template',
          url: 'sundry-item-stock'
        },
        {
          name: 'Formulation Stock Template',
          url: 'formulation-stock'
        },
      ]
    }
  },
  async mounted() {
    this.tenantId = this.$route.params.id;
  },
  methods: {
    formatName(name) {
      if (!name) return ''

      return name
        .replace(/ template$/i, '')     // remove ending "_Template"
        .replace(/[-_]+/g, ' ')         // replace "_" and "-" with space
        .replace(/\s+/g, ' ')           // clean extra spaces
        .trim()
        .replace(/\b\w/g, c => c.toUpperCase()) // capitalize words
    },
    async downloadFile(template) {
      this.$vs.loading();
      try {
        if (!template.url) return;

        const response = await TenantRepository.downloadTemplateDocument(
          this.tenantId,
          template.url
        );

        let fileURL = window.URL.createObjectURL(
          new Blob([response.data])
        );

        let fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', `${template.name}.xlsx`);
        document.body.appendChild(fileLink);
        fileLink.click();
      } catch (error) {
        console.log(error.message);
      } finally {
        this.$vs.loading.close();
      }
    }
  }
}
</script>

<style scoped></style>